<template>
  <div>
    <v-row>
      <v-col cols="12" md="12">
        <m-form
            :title="title"
            :showList="true"
            :cols="cols"
            @click:row="setItem"
            api-url="main/business/all"
            :show-submit-and-clear-btn="false"
            :show-list-btn="false"
            :canDelete="item.id >= 1"
            :items="items"
            :canSubmit="canSubmit"
            :isEditing.sync="isEditing"
            :show-navigation-btns="false"
            @submit="submit"
            @delete="deleteItem"
            @clearForm="clearForm()"
            ref="BusinessForm"
        >
          <template>
            <v-row v-if="item.id">
              <v-col cols="12">
                <v-img
                    @click="change_logo_dialog = true"
                    class="mr-2"
                    style="cursor: pointer"
                    v-if="!item.logo"
                    contain
                    max-height="90"
                    max-width="90"
                    src="/img/icons/photo.svg"
                />
                <v-avatar class="mr-2" v-if="item.logo" size="100" style="cursor: pointer"
                          @click="change_logo_dialog = true">
                  <v-img class="rounded-lg" :src="img_source(item.logo)"/>
                </v-avatar>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-autocomplete
                    class="rounded-lg"
                    :rules="[rules.required,]"
                    label="نوع کسب و کار"
                    :items="BUSINESS_TYPE"
                    v-model="item.business_type"
                    item-text="name"
                    item-value="value"
                    :disabled="!isEditing"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field label="* نام کسب و کار "
                              v-model="item.name" background-color="white" class="rounded-lg"
                              :disabled="!isEditing" :rules="[rules.required,]"/>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <user-select
                  user-type="buow"
                  class="rounded-lg"
                  label="صاحب کسب و کار"
                  v-model="item.admin"
                  :disabled="!isEditing"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field class="rounded-lg"
                              label="آدرس دامنه "
                              v-model="item.domain_address" background-color="white" :disabled="!isEditing"/>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field class="rounded-lg" v-on:keydown="NumbersOnly"
                              label="شماره تلفن "
                              v-model="item.phone" background-color="white" :disabled="!isEditing"/>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field class="rounded-lg"
                              label="توکن API "
                              v-model="item.api_token" background-color="white" :disabled="true"/>

              </v-col>
            </v-row>

            <v-row v-if="item.id">
              <v-col :cols="isXs?12:4">
                <label> رنگ اصلی</label>
                <v-color-picker
                    elevation="0"
                    v-model="item.primary_business_color">
                </v-color-picker>
              </v-col>
              <v-col :cols="isXs?12:4">
                <label> رنگ ثانویه</label>
                <v-color-picker
                    elevation="0"
                    v-model="item.secondary_business_color">
                </v-color-picker>
              </v-col>
              <v-col :cols="isXs?12:4">
                <label> رنگ تم</label>
                <v-color-picker
                    elevation="0"
                    v-model="item.theme_business_color">
                </v-color-picker>
              </v-col>
            </v-row>


            <v-row>
              <v-col cols="12">
                <v-textarea label=" درباره کسب و کار" rows="3"
                            v-model="item.about_us" background-color="white" class="rounded-lg"
                            :disabled="!isEditing"/>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-textarea label=" آدرس کسب و کار" rows="3"
                            v-model="item.address" background-color="white" class="rounded-lg"
                            :disabled="!isEditing"/>
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-dialog
                  v-model="change_logo_dialog"
                  class="rounded-lg"
                  persistent
                  @click:outside="change_logo_dialog=false"
                  max-width="400"
              >
                <v-card class="rounded-lg pa-2">
                  <v-card-title class="primary--text text-h5">
                    تغییر لوگو کسب و کار
                  </v-card-title>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" md="12">
                        <m-file-input
                            label="انتخاب لوگو"
                            v-model="logo"
                            :delete-attachment.sync="delete_logo"
                        />
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        text
                        @click="change_logo_dialog = false"
                    >
                      بستن
                    </v-btn>
                    <v-btn
                        color="success"
                        text
                        @click="updateLogo(item)"
                    >
                      تغییر لوگو
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-row>
            <v-row justify="center">
              <v-dialog
                  v-model="change_business_owner_national_card_picture_dialog"
                  class="rounded-lg"
                  persistent
                  @click:outside="change_business_owner_national_card_picture_dialog=false"
                  max-width="400"
              >
                <v-card class="rounded-lg pa-2">
                  <v-card-title class="primary--text text-h5">
                    تغییر عکس کارت ملی صاحب کسب و کار
                  </v-card-title>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" md="12">
                        <m-file-input
                            label="بارگذاری عکس کارت ملی صاحب کسب و کار"
                            v-model="logo"
                            :delete-attachment.sync="delete_logo"
                        />
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        text
                        @click="change_business_owner_national_card_picture_dialog = false"
                    >
                      بستن
                    </v-btn>
                    <v-btn
                        color="success"
                        text
                        @click="updateBusinessOwnerNationalCardPicture(item.id)"
                    >
                      بارگذاری
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-row>

          </template>
        </m-form>

      </v-col>
    </v-row>
  </div>

</template>

<script>

import {MFormMixin} from "@/components/m-form";
import FormsMixin from "@/mixin/forms";
import {PathLevels, VisitorLevels} from "@/variables";
import formsMixin from "@/mixin/forms";
import money from "@/components/mcomponents/cleave/Money";
import cart from "@/components/scomponents/Cart";
import UserSelect from "@/components/selects/UserSelect";


export default {
  name: "SupplierForm",
  mixins: [MFormMixin, formsMixin, FormsMixin],
  components: {
    UserSelect,
    cart
  },

  props: {
    id: {},
  },
  data() {
    return {
      printUrl: 'main/business/all',
      baseUrl: "main/business",
      permissionBasename: "business",
      appendSlash: false,
      hasList: false,
      no_edit_dialog: false,
      hasIdProp: true,
      change_logo_dialog: false,
      change_business_owner_national_card_picture_dialog: false,
      show_setting: false,
      hasLock: false,
      error_dialog: false,
      error_message: null,
      delete_business_owner_national_card_picture: null,
      business_owner_national_card_picture: null,
      delete_logo: null,
      logo: null,
      isDefinable: false,
      myClass: '',
      ss: null,
      PathLevels,
      VisitorLevels,
      paymentDialog: false,
      payment: '',
      performClearForm: true,
      items: [],
      first: false,
      BUSINESS_TYPE: [
        {name: ' فروشگاه اینترنتی', value: 'om'},
        {name: 'فروشنده پورسانتی', value: 'cs'},
        {name: 'فروشگاه نمایندگی', value: 'rm'},
      ],

      cols: [
        {
          text: "نوع",
          value: "business_type_display",
        },

        {
          text: "نام",
          value: "name",
        },
      ],

    };
  },
  computed: {
    rules() {
      return {
        max_cart: (v) => v.length <= 19 || "Max 19 characters",
        max_sheba: (v) => v.length <= 29 || "Max 29 characters",
        max_non_iranian_national_code: (v) =>
            v.length <= 12 || "Max 12 characters",
        min_cart: (v) => v.length >= 19 || "Min 19 characters",
        min_sheba: (v) => v.length >= 29 || "Min 29 characters",
        min_non_iranian_national_code: (v) =>
            v.length >= 12 || "Min 12 characters",
      };
    },
    title() {
      return 'کسب و کار'
    },
    headers() {
      return [];
    },
  },
  updated() {
  },
  created() {
  },
  methods: {
    NumbersOnly(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
        ;
      } else {
        return true;
      }
    },
    getUpdateLogoSerialized(selectItem) {
      let item = {
        id: selectItem.id,
        logo: this.logo,
        delete_logo: this.delete_logo,
      };

      if (typeof item["logo"] == typeof "") {
        delete item["logo"];
      }

      return this.jsonToFormData(item);
    },

    updateLogo(selectItem) {
      this.request({
        url: this.endpoint(`main/businessLogoUpdate/${selectItem.id}`),
        method: "put",
        data: this.getUpdateLogoSerialized(selectItem),
        success: (data) => {
          this.successNotify();
          this.isEditing = false;
          this.change_logo_dialog = false
          this.$refs.BusinessForm.$refs.datatable.getDataFromApi()
          this.setItem(data)
        },
      });
    },

    getUpdateBusinessOwnerNationalCardPictureSerialized(id) {
      let item = {
        id: id,
        business_owner_national_card_picture: this.business_owner_national_card_picture,
        delete_business_owner_national_card_picture: this.delete_business_owner_national_card_picture,
      };

      if (typeof item["business_owner_national_card_picture"] == typeof "") {
        delete item["business_owner_national_card_picture"];
      }
      return this.jsonToFormData(item);
    },

    updateBusinessOwnerNationalCardPicture(id) {
      this.request({
        url: this.endpoint(`main/businessOwnerNationalCardPictureUpdate/${id}`),
        method: "put",
        data: this.getUpdateBusinessOwnerNationalCardPictureSerialized(id),
        success: (data) => {
          this.successNotify();
          this.isEditing = false;
        },
      });
    },


  },
}
</script>

<style scoped lang="scss"></style>

